import { AgelessAssessmentFlowType } from "@orval/model";

export const VALID_FLOWS = [
  AgelessAssessmentFlowType.Aesthetics,
  AgelessAssessmentFlowType.Wellness,
  AgelessAssessmentFlowType.AestheticsWellness,
  AgelessAssessmentFlowType.LashBrow,
] as const;

/** URL slug (lowercase) -> enum value. Includes canonical + legacy aliases. */
export const FLOW_SLUG_MAP: Record<string, AgelessAssessmentFlowType> = {
  "try-on": AgelessAssessmentFlowType.Aesthetics,
  "wellness": AgelessAssessmentFlowType.Wellness,
  "transformation": AgelessAssessmentFlowType.AestheticsWellness,
  "lash-brow": AgelessAssessmentFlowType.LashBrow,
  // Legacy aliases — kept so old URLs still resolve.
  "aesthetics": AgelessAssessmentFlowType.Aesthetics,
  "aesthetics-wellness": AgelessAssessmentFlowType.AestheticsWellness,
};

/** Enum value -> canonical URL slug (lowercase) */
export const FLOW_TO_SLUG: Record<AgelessAssessmentFlowType, string> = {
  [AgelessAssessmentFlowType.Aesthetics]: "try-on",
  [AgelessAssessmentFlowType.Wellness]: "wellness",
  [AgelessAssessmentFlowType.AestheticsWellness]: "transformation",
  [AgelessAssessmentFlowType.LashBrow]: "lash-brow",
};

/** Maps a legacy flow slug to its canonical replacement. */
export const LEGACY_FLOW_SLUG_MAP: Record<string, string> = {
  "aesthetics": "try-on",
  "aesthetics-wellness": "transformation",
};

export const PROCESSING_TIMEOUT_MS = 70_000;
export const MIN_REVEAL_PROCESSING_DURATION_MS = 5_000;
export const MAX_REVEAL_PROCESSING_DURATION_MS = 25_000;
export const POLL_INTERVAL_MS = 3_000;

/**
 * If a complete assessment (comprehensiveAnalysisProcessingComplete + valid score)
 * arrives within this many milliseconds of component mount, the data came from
 * React Query cache (a refresh / back-navigation scenario) and we skip the
 * processing loader entirely.  A fresh analysis call takes several seconds so
 * 1 500 ms is safely below any real completion time.
 */
export const PROCESSING_BYPASS_WINDOW_MS = 1_500;
